module.exports = __webpack_public_path__ + "static/media/leftArrow.4a145ff3.svg";